package com.jingfangpai.content.model

import com.jingfangpai.common.orm.mapping.enums.ContentEntityType
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class ContentQuery {
    var type:ContentType?=null
    var entityType: ContentEntityType?=null
    var entityId:String?=null
    //var parentId:String?=null
    var id:String?=null
    var keyword:String?=null
    var signSymptomIds: Array<String>?=null
    var prescriptionIds:Array<String>?=null
    var medicineIds:Array<String>?=null
    var includeComments:Boolean?=null
}